import { render, staticRenderFns } from "./GuideEditor.vue?vue&type=template&id=2565f0d8&"
import script from "./GuideEditor.vue?vue&type=script&lang=js&"
export * from "./GuideEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GuideEditor.vue"
export default component.exports